module.exports = __webpack_public_path__ + "static/media/CentraleSansMedium.1dc8ef19.ttf";